app.component('eatlifeCheckTop', {
    templateUrl: 'app/eatlife/eatlife_check_top.html',
    controller: function($location) {
        var $ctrl = this;
        $ctrl.movePage = function(path) {
            $location.path(path);
        }
    }
});
